import React from 'react';
import { Box, Button, IconButton, Modal } from '@material-ui/core';
import DeleteOutlineRounded from '@material-ui/icons/DeleteOutlineRounded';
import EditIcon from '@material-ui/icons/Edit';
import {
  deleteOneCourseAsync,
  getAllCoursesAsync,
} from './CourseStore/courseStoreSlice';
import { useDispatch } from 'react-redux';
import useToast from '../../../hooks/useToast';
import UpdateCourseForm from './UpdateCourseForm';
import useLoader from '../../../hooks/useLoader';
import CloseIcon from '@material-ui/icons/Close';

export const coursesColumn = [
  { Header: 'Program Name', accessor: 'category.name' },
  { Header: 'SKU', accessor: 'sku' },
  { Header: 'Course Name', accessor: 'title' },
  { Header: 'Status', accessor: 'status' },
  { Header: 'Price', accessor: 'price' },
  { Header: 'Dollar', accessor: 'metaData.priceInDollar' },
  {
    Header: 'Action',
    accessor: '',
    Cell: (val) => {
      const dispatch = useDispatch();
      const payload = val.cell.row.original;
      const { _id } = payload;
      const { handleLoader } = useLoader();
      const { ErrorToast, SuccessToast } = useToast();

      const [selectedId, setSelectedId] = React.useState(null);
      const [updateCourseOpen, setUpdateCourseOpen] = React.useState(false);
      const [openConfirmModal, setOpenConfirmModal] = React.useState(false);

      const handleUpdateCourseOpen = (courseData) => {
        setUpdateCourseOpen(courseData);
      };
      const handleUpdateCourseClose = () => setUpdateCourseOpen(false);

      const handleOpenConfirmModal = (id) => {
        setSelectedId(id);
        setOpenConfirmModal(true);
      };
      const handleCloseConfirmModal = () => {
        setSelectedId(null);
        setOpenConfirmModal(false);
      };

      const handleDeleteCourse = async (id) => {
        try {
          handleLoader(true);
          dispatch(deleteOneCourseAsync({ id }))
            .unwrap()
            .then((res) => {
              if (res) {
                SuccessToast(`Course deleted successfully.`);
                fetchData();
                handleLoader(false);
              } else {
                handleLoader(false);
              }
            });
        } catch (error) {
          handleLoader(false);
          ErrorToast(`Course could not be deleted. Please try again!`);
        }
        handleCloseConfirmModal();
      };

      const fetchData = async () => {
        try {
          dispatch(getAllCoursesAsync())
            .unwrap()
            .then(() => {});
        } catch (error) {
          console.log(error);
        }
      };

      const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 3,
        fontFamily: 'Rubik',
        borderRadius: '6px',
      };

      return (
        <Box display="flex">
          <IconButton onClick={() => handleUpdateCourseOpen(payload)}>
            <EditIcon color="secondary" />
          </IconButton>
          {/* disabled true for not breaking the ui in ath-global */}
          <IconButton
            onClick={() => handleOpenConfirmModal(_id)}
            // disabled={true}
          >
            <DeleteOutlineRounded htmlColor="#dfdfdf" />
            {/* color="primary" */}
          </IconButton>
          <Modal
            open={updateCourseOpen}
            onClose={handleUpdateCourseClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            <UpdateCourseForm
              fetchDefaultData={fetchData}
              defaultData={updateCourseOpen}
              handleClose={handleUpdateCourseClose}
            />
          </Modal>

          <Modal
            open={openConfirmModal}
            onClose={handleCloseConfirmModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            <Box sx={style}>
              <Box mb={5} sx={{ fontSize: 20, fontWeight: 'medium' }}>
                Are you sure you want to delete ?
              </Box>
              <Box sx={{ position: 'absolute', top: 5, right: 5 }}>
                <IconButton>
                  <CloseIcon onClick={handleCloseConfirmModal} />
                </IconButton>
              </Box>
              <Box display={'flex'} justifyContent="flex-end">
                <Box display={'flex'}>
                  <Box mr={1}>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={handleCloseConfirmModal}>
                      No
                    </Button>
                  </Box>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleDeleteCourse(selectedId)}>
                    Yes
                  </Button>
                </Box>
              </Box>
            </Box>
          </Modal>
        </Box>
      );
    },
  },
];
